<template>
    <transition-group type="transition" name="flip-list" tag="div" class="form-container">

        <slot name="header"></slot>

        <DocumentViewerSection
            v-for="section in orderedSections" :key="section.key"
            :id="section.key"
            :section="section"
            :selection="selection"
            :changeSelection="changeSelection">
        </DocumentViewerSection>

        <slot name="footer"></slot>

    </transition-group>
</template>

<script>
import {mapGetters} from 'vuex'
import DocumentViewerSection from './DocumentViewerSection'

export default {
    name: 'DocumentViewerForm',
    props: {
        selection: { // for highlighting in settings modal
            type: Object,
            required: false
        },
        changeSelection: {
            type: Function,
            required: false,
            default: () => {
            }
        }
    },
    components: {
        DocumentViewerSection
    },
    methods: {
        scrollFormToSection(sectionKey) {
            const sectionEl = document.getElementById(sectionKey)
            if (sectionEl) {
                sectionEl.scrollIntoView({behavior: 'smooth'})
            }
        }
    },
    computed: {
        ...mapGetters('doc_viewer_settings', [
            'sections'
        ]),

        orderedSections() {
            if (_.isArray(this.sections)) {
                return this.sections.filter(s => s.visible).sort((a, b) => a.order - b.order)
            }
            return []
        }
    },
    watch: {
        selection: {
            handler(a, b) {
                if (a && b && a.section !== b.section) {
                    this.scrollFormToSection(a.section)
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
    .form-container {
        overflow-y: auto;
        height: 100%;
    }
</style>
